import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { LOGO_URL } from "@/lib/api";

export const Preloader = ({ onDone }) => {
  const [show, setShow] = useState(true);
  const [pct, setPct] = useState(0);

  useEffect(() => {
    const iv = setInterval(() => setPct((p) => Math.min(100, p + Math.random() * 18 + 7)), 150);
    const t = setTimeout(() => {
      clearInterval(iv);
      setPct(100);
      setShow(false);
      onDone?.();
    }, 1900);
    return () => {
      clearInterval(iv);
      clearTimeout(t);
    };
  }, [onDone]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="preloader"
          className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#08080a] grain"
          exit={{ y: "-100%" }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
        >
          <div className="grid-floor absolute inset-0 opacity-40" />
          <div className="relative flex flex-col items-center gap-6 px-6">
            <motion.div
              initial={{ scale: 0.7, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
              className="relative"
            >
              <svg width="92" height="92" viewBox="0 0 100 100" className="turbo-spin">
                {Array.from({ length: 12 }).map((_, i) => (
                  <rect
                    key={i}
                    x="48" y="8" width="4" height="26" rx="2"
                    fill={i % 3 === 0 ? "#ff1e42" : "#4b5563"}
                    transform={`rotate(${i * 30} 50 50)`}
                  />
                ))}
                <circle cx="50" cy="50" r="12" fill="#101014" stroke="#ff1e42" strokeWidth="2" />
              </svg>
              <div className="absolute inset-0 -z-10 rounded-full bg-rose-600/30 blur-2xl" />
            </motion.div>
            <img src={LOGO_URL} alt="TURBOLUX AUTOSERVISS" className="h-12 w-auto object-contain sm:h-16" />
            <div className="relative h-[2px] w-56 overflow-hidden bg-white/10">
              <motion.div className="h-full bg-rose-500" animate={{ width: `${pct}%` }} transition={{ duration: 0.2 }} />
            </div>
            <div className="font-mono-t text-[10px] uppercase tracking-[0.35em] text-slate-500">
              SPOOLING UP · {Math.round(pct)}%
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
